import React from "react";
import useGetData from "../../../../hooks/apihooks/useGetData";
import PageTitleCard from "../../templates/PageTitleCard";
import PageHeading from "../../../templates/PageHeading";
import CurrentPath from "../../../templates/CurrentPath";
import RightArrow from "../../../templates/RightArrow";
import BackHome from "../../../templates/BackHome";
import SubHeadingText from "../../../common/SubHeadingText";
import { motion } from "motion/react";
import { fadeInAnimation } from "../../../animation/motionAnimation";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import _ from "lodash";
const ImageGallery = () => {
  const { data, isLoading, isError } = useGetData(
    "galleries",
    "getAllimagegallery"
  );

  return (
    <div>
      <PageTitleCard>
        <PageHeading>Gallery</PageHeading>
        <div className="flex justify-evenly items-center">
          <BackHome /> <RightArrow /> <CurrentPath>Gallery</CurrentPath>
        </div>
      </PageTitleCard>
      <div className="py-8 container mx-auto max-sm:px-8">
        <SubHeadingText>Our Galleries</SubHeadingText>
        <div className=" py-8 ">
          {isLoading
            ? Array.from({ length: 8 }).map((_, i) => (
                <Skeleton className="w-full h-80" key={i} />
              ))
            : data?.map((va, ind) => {
                return (
                  <div key={ind}>
                    <div className="text-md my-4">
                      <SubHeadingText>
                        <p className="text-md">
                          {_.capitalize(va?.gallery_name)}
                        </p>
                      </SubHeadingText>
                    </div>

                    <div className="grid grid-cols-5 lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 max-sm:grid-cols-1 gap-4 ">
                      {va?.image_url?.map((v, i) => {
                        return (
                          <motion.img
                            initial={{ opacity: 0.5 }}
                            whileInView={{ opacity: 1 }}
                            transition={{ duration: 0.8 }}
                            viewport={{ once: false, amount: 0.5 }}
                            key={i}
                            src={v?.image_url}
                            className="w-full h-72 object-cover"
                          />
                        );
                      })}
                    </div>
                  </div>
                );
              })}
        </div>
      </div>
    </div>
  );
};

export default ImageGallery;
